import { render } from "./BreadcrumbContact.vue?vue&type=template&id=6da8b79d&scoped=true"
import script from "./BreadcrumbContact.vue?vue&type=script&lang=js"
export * from "./BreadcrumbContact.vue?vue&type=script&lang=js"

import "./BreadcrumbContact.vue?vue&type=style&index=0&id=6da8b79d&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da8b79d"]])

export default __exports__